import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useMemberCycle({ cycleId, memberId }) {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    setInfo(null);

    axios
      .get(routes.api.students.enrollment(memberId), {
        params: { cycle_id: cycleId },
      })
      .then((response) => {
        setInfo(response.data.data);
      });
  }, [cycleId, memberId]);

  return info;
}
